import { Component, Input } from '@angular/core';
import { to64decode } from 'src/app/helpers/base64';
import { getLanguageCookie } from 'src/assets/language';
import { MatTableDataSource } from '@angular/material/table';
import { v4 } from "uuid";
import { addAlert, apiOfflineAsync } from "../../../../layouts/pages/pages.component";
import { sortArrayOfObjects } from 'src/app/helpers/sortArrayOfObjects';
import { CorporationService } from 'src/app/services/corporation/corporation.service';
import { localStorageToJsonAsync } from 'src/app/helpers/cookieToJson';
import { systemPermissionsNew } from 'src/app/helpers/systemPermissions';

@Component({
  selector: 'app-rules',
  templateUrl: './rules.component.html',
  styleUrls: ['./rules.component.scss']
})
export class RulesComponent {
  @Input() parameters: any = {}
  @Input() dimensions: any = {}

  selectedFlag: any = {
    lang: 'en',
    file: 'us.svg'
  };

  dataSource!: MatTableDataSource<any>;
  displayedColumns: string[] = ['name','action'];
  currentPage = 1;
  currentPageReq = 1;
  itemsPerPage = 10;

  is_new_rule: boolean = true;
  createType: boolean = false

  currentRule: any = {}
  searchType: string = ''
  typeArray: any[] = []
  newType = {name: ''};
  properties: any

  constructor(private corporationService: CorporationService) {
    this.dataSource = new MatTableDataSource();
  }

  async ngOnInit(){
    this.properties = await localStorageToJsonAsync()
    this.dataSource.data = this.parameters.item.rules ?? []
    this.newRule();

    await this.getCorporationTypeProcedure()
  }

  getNames(name: any){
    return name[to64decode(localStorage.getItem('language')).lang]
  }

  getLanguages(file: string){
    return getLanguageCookie(file, localStorage.getItem('language'))
  }

  isData(){
    return this.dataSource.data.length > 0
  }

  getDisplayedRows(): any[] {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    return this.dataSource.data.slice(startIndex, endIndex);
  }

  getColumns(){
    return this.displayedColumns.slice(1)
  }

  getItemsPerPage(){
    return this.itemsPerPage
  }

  getCurrentPages(): number{
    return this.currentPage
  }

  choseItemsPage(number: number){
    this.itemsPerPage = number;
    this.getDisplayedRows()
  }

  onPageChange(newPage: number, text: string): void {
    this.currentPage = newPage;
  }

  getTotalPages(): number {
    return Math.ceil(this.dataSource.data.length / this.itemsPerPage);
  }

  async checkValue() {
    let total = this.getTotalPages()
    if (this.currentPage > total) this.currentPage = total;
  }

  async selectRule(item: any){
    this.currentRule = { ...item }
    this.is_new_rule = false;
  }

  async newRule(){
    this.currentRule = {
      uuid: v4(),
      name: '',
      type: '',
      description: ''
    };

    this.is_new_rule = true;
  }

  async saveRule(){
    let inputs: any = []

    if(!this.parameters.isEdit){
      return
    }

    if (!this.currentRule.name || this.currentRule.name == '') {
      inputs.push('Name')
    }

    if (inputs.length > 0) {
      addAlert('orange', `${this.getLanguages('mandatoryField')}${inputs.join(`, `)}`)
      return
    }

    if(this.is_new_rule){
      this.dataSource.data.push(this.currentRule)
    }else{
      this.dataSource.data.find((item: any, index: number) => {
        if(item.uuid == this.currentRule.uuid){
          this.dataSource.data[index] = this.currentRule
        }
      })
    }

    await this.newRule()
  }

  async deleteRule(uuid: string) {
    this.dataSource.data = this.dataSource.data.filter(item => item.uuid !== uuid);
    this.parameters.item.rules = this.dataSource.data
    await this.newRule()
  }

  choseType(item: any, type: any){
    if(type.name == "New +"){
      this.createType = true;
      return
    }
    item.type = type.name
  }

  async setCorporationTypeProcedure(){
    let flag = false;

    this.typeArray.forEach((item: any) => {
      if(item.name == this.newType.name){
        addAlert('orange', this.getLanguages('businessSolution/modal/rules/errors/typeProcedure'))
        flag = true
        return
      }
    });

    if(flag){
      return
    }
    
    if(this.newType.name == 'New +'){
      addAlert('danger', this.getLanguages('auth/alert/nameReservedWord'))
      return
    }

    try {
      const response:any = await this.corporationService.setCorporationTypeProcedure(this.newType);
      if (response && [201, 202].includes(response.status) ) {
        addAlert('success', response.message)
        await this.getCorporationTypeProcedure();
      } else {
        addAlert('danger', response.message)
      }
    } catch (error: any) {
      await apiOfflineAsync(error)
    }
    this.createType = false;
    this.newType.name = ''
  }

  async initCorporationLandscape(){
    this.typeArray = []
    if(systemPermissionsNew('settings', 'corporations')){
      this.typeArray.push({name: 'New +'})
    }
    this.typeArray.push(...sortArrayOfObjects(this.parameters.optionsArray.proceduresTypeEnum))
  }

  async getCorporationTypeProcedure(event?: any) {
    try {
      const response: any = await this.corporationService.getCorporationTypeProcedure();
      if (response && response.data) {
        await this.initCorporationLandscape();
        this.typeArray.push(...sortArrayOfObjects(response.data))

      } else {
        throw new Error('Erro ao consultar corporations landscape!\nConsulta o administrador do sistema!');
      }
    } catch (error: any) {
      await apiOfflineAsync(error)
    }
  }
}
